import get from 'lodash/get';
import { push } from 'connected-react-router';
import { generatePath } from 'bento-ordering/utils/generatePath';
import { CART } from 'bento-ordering/cart/constants/entities';
import { openModal } from 'bento-ordering/base/actions/modal';

import { isMobileMedia } from 'bento-ordering/utils/media';
import {
  ADD_TO_CART_REQUEST,
  ADD_TO_CART_SUCCESS,
  ADD_TO_CART_FAILURE,
  FETCH_CART_REQUEST,
  FETCH_CART_SUCCESS,
  FETCH_CART_FAILURE,
  DELETE_CART_REQUEST,
  DELETE_CART_SUCCESS,
  DELETE_CART_FAILURE,
  REMOVE_CART_ITEM_REQUEST,
  REMOVE_CART_ITEM_SUCCESS,
  REMOVE_CART_ITEM_FAILURE,
  EDIT_CART_REQUEST,
  EDIT_CART_SUCCESS,
  EDIT_CART_FAILURE,
  EDIT_CART_ITEM_REQUEST,
  EDIT_CART_ITEM_SUCCESS,
  EDIT_CART_ITEM_FAILURE,
  RESET_CART_ERROR,
  EDIT_LOCATION_REQUEST,
  EDIT_LOCATION_SUCCESS,
  EDIT_LOCATION_FAILURE
} from 'bento-ordering/cart/constants/actionTypes';
import { apiAction } from 'bento-ordering/base/utils/apiHelpers';
import {
  OO_CART_ADD_ENDPOINT,
  CART_API_ENDPOINT,
  CART_JSON_ENDPOINT,
  OO_CART_API_ENDPOINT,
  OO_CART_LOCATION_API_ENDPOINT,
  getUpdateCartItemEndpoint
} from 'bento-ordering/base/constants/endpoints';
import { restartOnlineOrderingFlow } from 'bento-ordering/base/actions/setupInitialData';
import logError from 'bento-ordering/utils/logError';

export const addToCart = payload => dispatch => {
  const endpoint = OO_CART_ADD_ENDPOINT;

  return dispatch(
    apiAction(
      endpoint,
      'POST',
      [ADD_TO_CART_REQUEST, ADD_TO_CART_SUCCESS, ADD_TO_CART_FAILURE],
      payload
    )
  );
};

export const fetchCart = () => dispatch => {
  const endpoint = CART_JSON_ENDPOINT;

  return dispatch(
    apiAction(endpoint, 'GET', [
      FETCH_CART_REQUEST,
      FETCH_CART_SUCCESS,
      FETCH_CART_FAILURE
    ])
  );
};

export const clearCart = () => (dispatch, getState) => {
  const endpoint = CART_API_ENDPOINT;
  const state = getState();
  const currentItems = get(state, 'cart.items', []);
  const payload = currentItems.map(item => ({ id: item.id }));

  if (payload.length === 0) {
    return null;
  }

  return dispatch(
    apiAction(
      endpoint,
      'PUT',
      [DELETE_CART_REQUEST, DELETE_CART_SUCCESS, DELETE_CART_FAILURE],
      payload
    )
  ).then(response => {
    if (response.payload.status === 404) {
      dispatch(restartOnlineOrderingFlow());
    }
  });
};

export const removeCartItem = id => (dispatch, getState) => {
  const endpoint = CART_API_ENDPOINT;
  const state = getState();
  const currentItems = get(state, 'cart.items', []);
  const cartItem = currentItems.find(item => item.id === id);
  const payload = [{ id }];

  if (!cartItem) {
    return null;
  }

  return dispatch(
    apiAction(
      endpoint,
      'PUT',
      [
        REMOVE_CART_ITEM_REQUEST,
        REMOVE_CART_ITEM_SUCCESS,
        REMOVE_CART_ITEM_FAILURE
      ],
      payload
    )
  );
};

export const updateCartItem = (cartItemId, payload) => (dispatch, getState) => {
  const endpoint = getUpdateCartItemEndpoint(cartItemId);
  return dispatch(
    apiAction(
      endpoint,
      'PUT',
      [EDIT_CART_ITEM_REQUEST, EDIT_CART_ITEM_SUCCESS, EDIT_CART_ITEM_FAILURE],
      payload
    )
  );
};

/**
 * This is the same as edit cart except it's specific to edit location.
 * We are passing a different set of action types in here to distinguish
 * edit location from editing other cart fields. This is mainly for
 * loading a spinner when we edit the cart
 */
export const editLocationInCart = payload => dispatch => {
  const endpoint = OO_CART_LOCATION_API_ENDPOINT;
  return dispatch(
    apiAction(
      endpoint,
      'PUT',
      [EDIT_LOCATION_REQUEST, EDIT_LOCATION_SUCCESS, EDIT_LOCATION_FAILURE],
      payload
    )
  );
};

/*
payload here is an object with keys that include one of the following:  online_ordering_location, fulfillment_date, or fulfillment_time,  requested_fulfillment_is_asap
*/
export const editCart = payload => async (dispatch, getState) => {
  const endpoint = OO_CART_API_ENDPOINT;

  try {
    const response = await dispatch(
      apiAction(
        endpoint,
        'PUT',
        [EDIT_CART_REQUEST, EDIT_CART_SUCCESS, EDIT_CART_FAILURE],
        payload
      )
    );
    if (response.payload.status === 404) {
      return dispatch(restartOnlineOrderingFlow());
    }
  } catch (err) {
    logError(err);
  }
};

export const resetError = () => {
  return {
    type: RESET_CART_ERROR
  };
};

export const goToCart = () => dispatch => {
  if (!isMobileMedia()) {
    dispatch(openModal());
  }

  return dispatch(push(generatePath(CART, 'cart')));
};
